import config from "../config.js";
import Connexion from '../script/Connexion.js';

//export default class SSV {
export default {
    namespaced: true,

    state() {
        return {
            //connecte: false
        }
    },
    getters: {
        //getConnecte(state) {
        //    return state.connecte
        //},
    },
    mutations: {
        //connecter(state, obj) {
        //    Connexion.connecter(obj.id, obj.mdp).then(response => {
        //        state.connecte = response;
        //    });
        //}
    },

    actions: {
        //connecter({ commit, state }, obj) {
        //    commit('connecter', obj);
        //}, 
    }
}